/*------------------------------------*\
    filter/sort
\*------------------------------------*/

module.exports = function(){

    function changeProductViewImage (element, view) {
        let img = $(element).find('.js-shop-product-thumb'),
            imgLink = img.attr('data-' + view);

        $(element).addClass('is-loading')

        $(element).find('.js-shop-product-thumb').attr('src', imgLink)

        img.on('load', function() {
            $(element).removeClass('is-loading');
        });
    }

    $('.js-product-thumb-wrapper').mouseover(function() {
        let view = $('.js-shop-thumb-input').val() == 'model' ? 'fabric' : 'model'; // Change to fabric/model view

        changeProductViewImage(this, view)
    }).mouseout(function() {
        let view = $('.js-shop-thumb-input').val(); // Revert to view before hover
        
        changeProductViewImage(this, view)
    })

    // visual button

    $('.js-shop-thumb-set').on('click', function(event) {
        event.preventDefault();

        $('.js-shop-thumb-set').removeClass('is-active');
        $(this).addClass('is-active');

        $('.js-shop-thumb-input').val($(this).data('toggle'));
        $('.js-shop-thumb-input').trigger('change');
    });





    // hidden input

    $('.js-shop-thumb-input').on('change', function(event) {
        event.preventDefault();

        var self = $(this);



        $('.js-shop-products-wrapper').find('.js-shop-product-thumb').each(function(index, el) {


            $(el).closest('.js-product-thumb-wrapper').addClass('is-loading');

            var newSrc = $(el).attr('data-' +  self.val());

            $(el).attr('src', newSrc);




            // if showing fabric then show spinner and remove it after the fabric img loads
            if (self.val() === 'fabric') {

                $(el).one('load', function(event) {

                    setTimeout(function(){
                        $(el).closest('.js-product-thumb-wrapper').removeClass('is-loading');
                    }, 500);

                });

            }



            // original model img loaded before so we can't do detection like with fabric
            // there's still visible img change speed so show loader for some seconds
            else if (self.val() === 'model'){

                setTimeout(function(){
                    $(el).closest('.js-product-thumb-wrapper').removeClass('is-loading');
                }, 2000);

            }




        });


    });



}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/filter-shop.js